<!--  -->
<template>
    <div class="ExportDianlog">
        <div class="Dianlogbox">
            <div class="title">下载数据</div>
            <div class="inputbox">
                <span class="typebox">标识卡：</span>
                <el-select v-model="comanyid" filterable remote reserve-keyword placeholder="请输入关键词"
                    @click.native="defaultFun"
                    :remote-method="remoteMethod" :loading="loading">
                    <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="selectbox">
                <span class="typebox">案件状态：</span>
                <el-select v-model="state" placeholder="请选择">
                    <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="dateselect">
                <span class="typebox">标记日期：</span>
               
                    <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
                    </el-date-picker>
                
            </div>
            <div class="inputbox">
                <span class="typebox">数据排序:</span>
                <div class="radiobox">
                    <el-radio v-model="sort" label="1">按申请日期</el-radio>
                    <el-radio v-model="sort" label="2">按缴费期限</el-radio>
                </div>
            </div>
            <div class="tips">根据当前条件已筛选出<span class="totalrow" >{{ totalrow }}</span>条数据，即将为您下载Excel</div>
            <div class="btnbox">
                <el-button type="danger" @click="closeDianlog">取消</el-button>
                <el-button type="primary" @click="ok">确定</el-button>
            </div>
        </div>
        <loading v-if="showloading" :percentCompleted.sync="percentCompleted"></loading>
    </div>
</template>

<script>
import { yunSearch, downloadDataCount } from '@/api'
import axiosApi from '@/utils/AxiosReques'
import loading from './loading.vue';
import {getDate,getRand} from '@/utils/util'
export default {
    name: "ExportDianlog",
    components: { loading },
    data() {
        return {
            showloading: false,
            comanyid: '',//公司id
            options1: [],
            loading: false,
            options2: [
                {
                    value: '0',
                    label: '全部'
                },
                {
                    value: '1',
                    label: '正常'
                },
                {
                    value: '2',
                    label: '已过期'
                },
                {
                    value: '3',
                    label: '已失效'
                },
                {
                    value: '4',
                    label: '回收站'
                }
            ],
            state: '0',//状态
            date: new Date().toISOString().split('T')[0],//日期
            sort: '1',
            totalrow: 0,
            percentCompleted:0 //下载进度
        };
    },
    watch: {
        comanyid(newVal) {
            let params = {}
            params.sid = newVal
            params.state = this.state
            this.downloadDataCount(params)
        },
        state(newVal) {
            if (this.comanyid == '') {
                this.$message({ message: '请选择标识卡', type: 'error', offset: 500, duration: 1500 })
                return
            }
            let params = {}
            params.sid = this.comanyid
            params.state = newVal
            this.downloadDataCount(params)
        }
    },
    methods: {
        closeDianlog() {
            this.$emit('update:exportExcelsw', false)
        },
        async downloadDataCount(params) {
            let req = await downloadDataCount(params)
            if (req.state == 'ok') {
                this.totalrow = req.count
            }
        },
       async defaultFun(){
                let params = {}
                params.aid = this.wxData.aid
                let req = await yunSearch(params)
                if (req.state == 'ok') {
                    this.loading = false;
                    console.log(req)
                    this.options1 = req.data
                }
        },
        async remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                let params = {}
                params.aid = this.wxData.aid
                params.keyword = query
                let req = await yunSearch(params)
                if (req.state == 'ok') {
                    this.loading = false;
                    console.log(req)
                    this.options1 = req.data
                }
            }
        },
       //下载
       async ok() {
            if (this.comanyid == '') {
                this.$message({ message: '请选择标识卡', type: 'error', offset: 500, duration: 1500 })
                return
            }
            if (this.totalrow == 0) {
                this.$message({ message: '暂时无数据，请检查搜索条件', type: 'error', offset: 500, duration: 1500 })
                return
            }
            this.$message({ message: '正在为您下载数据，请稍后...', type: 'success', offset: 500, duration: 1500 })
            let params = {}
            params.sid = this.comanyid //公司id
            params.state = this.state //状态
            params.date = this.date //日期
            params.sort = this.sort //排序
            try {
                const res = await axiosApi.post('/api/Getinfo/outputExcel', params, {
                    responseType: 'blob', // 设置响应类型为 blob，
                    onDownloadProgress: (progressEvent) =>{
                        // 计算下载进度百分比
                        const percentCompleted = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        // 更新进度条的值
                        // console.log(percentCompleted)
                        this.showloading=true
                        this.percentCompleted=percentCompleted
                    }
                });
                // 创建 Blob 对象
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                // 创建一个临时的 URL
                const url = window.URL.createObjectURL(blob);
                // 创建一个 <a> 标签
                const a = document.createElement('a');
                a.href = url;
                // 查找公司名称
                const item = this.options1.find(option => option.id ==this.comanyid);
                const name = item ? item.name : undefined;
                a.download = `${name}_专利案件导出_${getDate('YYYYMMDD')}_${getRand()}.xlsx`; // 设置下载的文件名
                a.click();
                this.percentCompleted=0
                this.showloading=false
                this.$emit('update:exportExcelsw',false)
                // 释放临时 URL
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载文件时出错:', error);
            }
        }
    },
    mounted() {

    },
    beforeDestroy() {

    }
}
</script>
<style lang='scss' scoped>
.ExportDianlog {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.Dianlogbox {
    min-width: 800px;
    background-color: white;
    position: relative;
    padding: 60px 40px;
}

.el-icon-close {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 24px;
    cursor: pointer;
}

.title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
}

.inputbox {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.typebox {
    display: inline-block;
    width: 100px;
    text-align: end;
}

.radiobox {
    text-align: start;
    width: 300px;
    margin-left: 20px;
}

::v-deep .el-input {
    width: 300px;
}

.selectbox {
    text-align: center;
    margin-bottom: 20px;
}

.dateselect {
    text-align: center;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep .el-input__inner {
    width: 300px;
}

.tips {
    text-align: center;
    color: green;
    margin-bottom: 20px;
}

.btnbox {
    padding: 0 260px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
}
.totalrow{
    color: red;
    display: inline-block;
    margin: 0 4px;
    font-weight: bold;
    font-size: 18px;
}
.block{
    width: 300px;
    
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 300px;
}
</style>